import UnsubscibePage from "./UnsubscibePage";

export default UnsubscibePage;
